var __extends =
  (this && this.__extends) ||
  (function () {
    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b;
          }) ||
        function (d, b) {
          for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        };
      return extendStatics(d, b);
    };
    return function (d, b) {
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype =
        b === null
          ? Object.create(b)
          : ((__.prototype = b.prototype), new __());
    };
  })();
define("SuiteCommerce.Blog.Post.View", [
  "require",
  "exports",
  "PageType.Base.View",
  "SuiteCommerce.Blog.Post.Model",
  "sc_blog_post_default_layout.tpl",
  "SuiteCommerce.Blog.Common",
  "SuiteCommerce.Blog.Post.Header.View",
  "SuiteCommerce.Blog.Post.Content.View",
  "SuiteCommerce.Blog.Post.Header.Image.View",
  "SuiteCommerce.Blog.Post.Footer.View",
  "SuiteCommerce.Blog.BlogHome.Configuration",
  "SuiteCommerce.Blog.Instrumentation",
  "Backbone",
  "SuiteCommerce.Blog.DataProvider",
  "SuiteCommerce.Blog.Common.Configuration",
  "underscore",
], function (
  require,
  exports,
  PageType_Base_View_1,
  Post_Model_1,
  postTemplate,
  Common_1,
  Post_Header_View_1,
  Post_Content_View_1,
  Post_Header_Image_View_1,
  Post_Footer_View_1,
  BlogHome_Configuration_1,
  Instrumentation_1,
  Backbone_1,
  DataProvider_1,
  Configuration_1,
  _
) {
  "use strict";
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.prototype = exports.PostView = void 0;
  var PostView = /** @class */ (function (_super) {
    __extends(PostView, _super);
    function PostView(options) {
      var _this = _super.call(this, options) || this;
      _this.template = postTemplate;
      _this.childViews = {
        "Header.View": function () {
          return new Post_Header_View_1.PostHeaderView({ model: _this.model });
        },
        "Header.Image.View": function () {
          return new Post_Header_Image_View_1.PostHeaderImageView({
            model: _this.model,
          });
        },
        "Content.View": function () {
          return new Post_Content_View_1.PostContentView({
            model: _this.model,
          });
        },
        "Footer.View": function () {
          return new Post_Footer_View_1.PostFooterView({ model: _this.model });
        },
      };
      _this.model =
        /* SC/SCA >= 20.2: option.pageInfo is a Backbone Model
         * SC/SCA < 20.2: option.pageInfo is an Object */
        options.pageInfo instanceof Backbone_1.Model
          ? new Post_Model_1.PostModel(options.pageInfo.toJSON())
          : new Post_Model_1.PostModel(options.pageInfo);
      // Required for SC/SCA < 20.2
      _this.application = options.container;
      _this.addChildViewInstances(_this.childViews);
      _this.getBreadcrumbPages = _this.getBreadcrumbConstructor();
      _this.registerQuantityOfTagsLog();
      return _this;
    }
    PostView.prototype.beforeShowContent = function () {
      var _this = this;
      var renderPromise = jQuery.Deferred();
      if (Configuration_1.Configuration.isEnabledJSONLd) {
        this.setupJSONLdData().done(function () {
          _this.addJSONLdData(_this.model, _this.application);
        });
      }

      fetch(
        `https://${window.location.hostname}/app/site/hosting/scriptlet.nl?script=2151&deploy=1&compid=1144330&ns-at=AAEJ7tMQ2pp5iJnInWTsy6FPz0Vcp4DXnnCvydW0992VBjUqfSY`

      )
        .then((res) => res.json())
        .then((result) => {
          if (result.success) {
            this.instagramMedia = JSON.parse(result.media);
          }
        })
        .catch((err) => {
          console.log(err, "fetching insta media");
        })
        .finally(() => {
          renderPromise.resolve();
        });

      return renderPromise;
    };
    PostView.prototype.setupJSONLdData = function () {
      var entitiesModelPromise = jQuery.Deferred();
      var imagesPromise = jQuery.Deferred();
      DataProvider_1.DataProvider.entitiesModel.isSync
        ? entitiesModelPromise.resolve()
        : DataProvider_1.DataProvider.entitiesModel.on(
            "change:isSync",
            function () {
              if (DataProvider_1.DataProvider.entitiesModel.isSync) {
                entitiesModelPromise.resolve();
              }
            }
          );
      this.model.imagesIdsWithoutUrl.length > 0
        ? DataProvider_1.DataProvider.files.on("sync", function () {
            imagesPromise.resolve();
          })
        : imagesPromise.resolve();
      return jQuery.when(entitiesModelPromise, imagesPromise);
    };
    PostView.prototype.addJSONLdData = function (post, container) {
      var _this = this;
      var layout = container.getComponent("Layout");
      if (layout) {
        layout.modifyViewJsonLd(
          "SuiteCommerce.Blog.Post.View",
          function (json) {
            json = _.extend(json, _this.generateJSONLdSchema(post));
            return jQuery.Deferred().resolve(json);
          }
        );
      }
    };
    PostView.prototype.generateJSONLdSchema = function (post) {
      return {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": location.origin + post.url,
        },
        headline: post.header,
        alternativeHeadline: post.title,
        articleSection: post.categoryName,
        image:
          post.headerImageURL || post.thumbnailImageURL
            ? location.origin + (post.headerImageURL || post.thumbnailImageURL)
            : undefined,
        keywords: post.tags,
        datePublished: post.publishingDateUnformatted,
        description: post.excerpt,
        author: {
          "@type": "Person",
          name: post.authorName || "Anonymous",
          url: post.authorUrl ? location.origin + post.authorUrl : undefined,
        },
        publisher: {
          "@type": "Organization",
          name: Configuration_1.Configuration.get("siteSettings.displayname"),
          url: location.origin,
          logo: {
            "@type": "ImageObject",
            url: Common_1.resizeImage(
              Configuration_1.Configuration.get("header.logoUrl"),
              "thumbnail"
            ),
          },
        },
      };
    };
    PostView.prototype.getBreadcrumbConstructor = function () {
      var _this = this;
      return function () {
        var pages = [
          {
            text: BlogHome_Configuration_1.BlogHomeConfiguration.blogHomeTitle,
            href: "" + Common_1.BLOG_URL_BASE,
          },
        ];
        if (_this.model && _this.model.title) {
          pages.push({
            text: _this.model.title,
            href: "" + _this.model.url,
          });
        }
        return pages;
      };
    };

    PostView.prototype.getContext = function () {
      return {
        instagramMedia: this.instagramMedia || [],
      };
    };
    PostView.prototype.registerQuantityOfTagsLog = function () {
      var log = Instrumentation_1.default.getLog("quantityOfTagsLog");
      log.setParameters({
        activity: "Tags Usage",
        instanceCount: this.model.tags.length,
      });
      log.submit();
    };
    return PostView;
  })(PageType_Base_View_1.PageTypeBaseView);
  exports.PostView = PostView;
  //Workaround for SCA 2020.1 (JSON Ld generation)
  exports.prototype = PostView.prototype;
});
